<section class="content-layout content-layout-1">
  <div class="container">
    <div class="row">
      <aside class="col-sm-12 col-lg-5 sticky">
        @if (data().image; as image) {
          <app-image [image]="image" [size]="{ dw: 486, dh: 729, mh: 491 }" class="img" />
        }
      </aside>
      <div class="col-sm-12 col-lg-6 col-lg-offset-1">
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
        @if (data().html; as html) {
          <div [innerHTML]="html" class="paragraph"></div>
        }
        @if (data().cta; as cta) {
          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT' }"
            [label]="cta.label"
            [size]="'NORMAL'"
            [theme]="'TRANSPARENT_BLACK'"
            [url]="cta.url"
            class="button" />
        }
      </div>
    </div>
  </div>
</section>
